// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Typography } from '@mui/material';
import { Button } from '@mui/material'
import { Box } from '@mui/material'
import React from 'react'
import __t from '../../../../lib/traduzioni';
import Whitespace from '../../../Whitespace';
import useBSSLogger from '../../../../hooks/useBSSLogger';
import { orderFromCart } from '../../../../api/testataordine';
import { useContext } from 'react';
import BSSPreventivoContext from '../../../../contexts/BSSPreventivoContext';
import { useLocalStorage, useSearchParam } from 'react-use';
import { convertiFormRequestCalcola } from '../../Preventivo';
import { nextUrlByStep } from '../FrammentoRiepilogo';
import TabelleEntries from '../../../TabelleEntries';
import { pagamentoNonElettronico } from '../../../../api/pagamenti';
import { createNotifiesPaypal, execute, preExecRequestPaypal } from '../../../../lib/pagautils';
import { useEffect } from 'react';
import { useState } from 'react';
import BSSSnackbar from '../../../form/BSSSnackbar';
import { Alert } from '@mui/material';
import { confirmPayment } from '../../../../api/paypal';
import { CalendarTodayRounded } from '@mui/icons-material';
import { AccountBalance } from '@mui/icons-material';
import { CreditCard } from '@mui/icons-material';

const {logger} = useBSSLogger();

const icone = { 
    "PAGAFINEMESE": CalendarTodayRounded,
    "BONIFICO": AccountBalance,
    "PAYPAL": CreditCard
}

const defaultAvvisi = {mostra: false, severity: 'error', message: null}

const Paga = ({parametri, methods, modalita}) => {

    const [avvisi, setAvvisi] = useState(defaultAvvisi)

    const contesto = useContext(BSSPreventivoContext);
    const [carrelloStorage = {preventivi: [], pagamenti: {}, datiFatturazione: {}}, aggiornaCarrelloStorage, rimuoviCarrelloStorage] = useLocalStorage("spedizioniweb2_preventivo_carrello");
    const {preventivoStorage = {}, rimuoviPreventivoStorage, datiFatturazione, tipiPersone, backdropPreventivo, setBackdropPreventivo} = contesto;
    const {id: idmodpag, nome, codice, totaleConCommissione, totalecarrello} = modalita;

    const pagamentoPayPal = useSearchParam("paypalResult")
    useEffect(()=>{
        if(codice === "PAYPAL"){
            
            if(pagamentoPayPal === 'success'){

                setAvvisi({
                    severity: "success",
                    message: __t("successopaypal"),
                    mostra: true

                })

                let parametriExec = {
                    event: {preventDefault: () => {}}, 
                    modalita, 
                    methods, 
                    execPayment: () => {}, 
                    carrelloStorage,
                    rimuoviCarrelloStorage, 
                    rimuoviPreventivoStorage,        
                    backdropPreventivo,
                    setBackdropPreventivo,
                    specificNotifier: createNotifiesPaypal                
                }
        
                execute(parametriExec)       
            }
            
            if(pagamentoPayPal === 'error'){
                setAvvisi({
                    ...defaultAvvisi,
                    message: __t("errorepaypal"),
                    mostra: true

                })
            }

        } 
    }, [pagamentoPayPal])

    const handleSubmit = async (event) => {

        let parametriExec = {
            event, 
            modalita, 
            methods, 
            execPayment: pagamentoNonElettronico, 
            carrelloStorage,
            rimuoviCarrelloStorage, 
            rimuoviPreventivoStorage,        
            backdropPreventivo,
            setBackdropPreventivo                
        }

        if(codice === "PAYPAL"){
            parametriExec.specificPreExecRequest = preExecRequestPaypal
            parametriExec.preExecRequestParams = parametri
        }

        await execute(parametriExec)        

    }
    
    const Icona = icone[codice];

    let tabelle = null;
    let nparametri = 0;
    if(codice === "BONIFICO"){

        const arrparametri = Object.values(parametri);
        nparametri = arrparametri.length;

        tabelle = {
            [__t("coordinate")]: arrparametri.reduce((obj, {nome, valore}) => {
                obj[nome] = valore;
                return obj;
            }, {})
        }
    }

    return (
        <>
            <Box px={1}>

                {codice === "BONIFICO" && nparametri > 0 && (
                    <>
                        {/* <pre>{JSON.stringify(parametri, null, 2)}</pre> */}
                        <TabelleEntries wrapped tabelle={tabelle} />
                    </>
                    
                )}

                <Button sx={{width: "100%"}} variant="contained" onClick={handleSubmit}>
                    <Typography variant='h6'>
                        <Icona  />
                        <Whitespace />
                        {codice === "BONIFICO" ? 
                            `${__t("pagaconbonifico")}` : 
                            codice === "PAYPAL" ? 
                                `${__t("pagaconpaypal")}` : 
                                nome
                        } 
                        
                        <>
                            <Whitespace />
                            <b>
                                {`€ ${totaleConCommissione ?? totalecarrello}`}
                            </b>
                        </>
                    
                    </Typography>                        
                </Button>  
            </Box>
            {codice === "PAYPAL" && (
                <BSSSnackbar open={avvisi.mostra} onClose={e => setAvvisi(defaultAvvisi)}>
                    <Alert onClose={e => setAvvisi(defaultAvvisi)} severity={avvisi.severity}>
                        {avvisi.message}
                    </Alert>
                </BSSSnackbar>
            )}
        </>
    )
}

export default Paga